import React from "react";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import activitySvg from "../../assets/svgs/activity.svg"
import ambulantSvg from "../../assets/svgs/ambulant.svg"
import acuityBSvg from "../../assets/svgs/acuityB.svg"
import cardiacMonitoringSvg from "../../assets/svgs/cardiacMonitoring.svg"
import infectionSvg from "../../assets/svgs/infection.svg"
import InfectionRiskSvg from "../../assets/svgs/InfectionRisk.svg"
import ivInfusionIconSvg from "../../assets/svgs/ivInfusionIcon.svg"
import medicationSvg from "../../assets/svgs/medication.svg"
import memoryLossIconSvg from "../../assets/svgs/memoryLossIcon.svg"
import nilByMouthIconSvg from "../../assets/svgs/nilByMouthIcon.svg"
import nonambulantSvg from "../../assets/svgs/nonambulant.svg"
import o2DeliveryIconSvg from "../../assets/svgs/o2DeliveryIcon.svg"
import patientDisplaysAggressionSvg from "../../assets/svgs/patientDisplaysAggression.svg"
import potentiallySvg from "../../assets/svgs/potentially.svg"
import prescribedMedicationSvg from "../../assets/svgs/prescribedMedication.svg"
import sedatedSvg from "../../assets/svgs/sedated.svg"
import mentalHealthSvg from "../../assets/svgs/mentalHealth.svg"
import translatorSvg from "../../assets/svgs/translator.svg"

// DARK ICONS
import activityDarkSvg from "../../assets/svgs/black/activity.svg"
import ambulantDarkSvg from "../../assets/svgs/black/ambulant.svg"
import acuityBDarkSvg from "../../assets/svgs/black/acuityB.svg"
import cardiacMonitoringDarkSvg from "../../assets/svgs/black/cardiacMonitoring.svg"
import infectionDarkSvg from "../../assets/svgs/black/infection.svg"
import InfectionRiskDarkSvg from "../../assets/svgs/black/InfectionRisk.svg"
import ivInfusionIconDarkSvg from "../../assets/svgs/black/ivInfusionIcon.svg"
import medicationDarkSvg from "../../assets/svgs/black/medication.svg"
import memoryLossIconDarkSvg from "../../assets/svgs/black/memoryLossIcon.svg"
import nilByMouthIconDarkSvg from "../../assets/svgs/black/nilByMouthIcon.svg"
import nonambulantDarkSvg from "../../assets/svgs/black/nonambulant.svg"
import o2DeliveryIconDarkSvg from "../../assets/svgs/black/o2DeliveryIcon.svg"
import patientDisplaysAggressionDarkSvg from "../../assets/svgs/black/patientDisplaysAggression.svg"
import potentiallyDarkSvg from "../../assets/svgs/potentially.svg"
import prescribedMedicationDarkSvg from "../../assets/svgs/black/prescribedMedication.svg"
import sedatedDarkSvg from "../../assets/svgs/black/sedated.svg"
import mentalHealthDarkSvg from "../../assets/svgs/black/mentalHealth.svg"
import translatorDarkSvg from "../../assets/svgs/black/translator.svg"

const ICONS_LIGHT: any = {
  "activity.svg": activitySvg,
  "ambulant.svg": ambulantSvg,
  "acuityB.svg": acuityBSvg,
  "cardiacMonitoring.svg": cardiacMonitoringSvg,
  "infection.svg": infectionSvg,
  "InfectionRisk.svg": InfectionRiskSvg,
  "ivInfusionIcon.svg": ivInfusionIconSvg,
  "medication.svg": medicationSvg,
  "memoryLossIcon.svg": memoryLossIconSvg,
  "nilByMouthIcon.svg": nilByMouthIconSvg,
  "nonambulant.svg":nonambulantSvg,
  "o2DeliveryIcon.svg":o2DeliveryIconSvg,
  "patientDisplaysAggression.svg": patientDisplaysAggressionSvg,
  "potentially.svg": potentiallySvg,
  "prescribedMedication.svg": prescribedMedicationSvg,
  "sedated.svg": sedatedSvg,
  "mentalHealth.svg": mentalHealthSvg,
  "translator.svg": translatorSvg,
};

const ICONS_DARK: any = {
  "activity.svg": activityDarkSvg,
  "ambulant.svg": ambulantDarkSvg,
  "acuityB.svg": acuityBDarkSvg,
  "cardiacMonitoring.svg": cardiacMonitoringDarkSvg,
  "infection.svg": infectionDarkSvg,
  "InfectionRisk.svg": InfectionRiskDarkSvg,
  "ivInfusionIcon.svg": ivInfusionIconDarkSvg,
  "medication.svg": medicationDarkSvg,
  "memoryLossIcon.svg": memoryLossIconDarkSvg,
  "nilByMouthIcon.svg": nilByMouthIconDarkSvg,
  "nonambulant.svg":nonambulantDarkSvg,
  "o2DeliveryIcon.svg": o2DeliveryIconDarkSvg,
  "patientDisplaysAggression.svg": patientDisplaysAggressionDarkSvg,
  "potentially.svg": potentiallyDarkSvg,
  "prescribedMedication.svg": prescribedMedicationDarkSvg,
  "sedated.svg": sedatedDarkSvg,
  "mentalHealth.svg": mentalHealthDarkSvg,
  "translator.svg": translatorDarkSvg,
};

export const NeedIcon = ({ iconName, theme = "dark" }: any) => {
  if (!iconName || iconName == "") return null;
  return <span style={{ marginRight: 6 }}>{theme == "dark" ? <img src={ICONS_LIGHT[iconName]} /> : <img src={ICONS_DARK[iconName]} />}</span>;
};

export const NeedListItem = ({ iconUrl, theme = "dark" }: any) => {
  let imageName = (iconUrl ? iconUrl.split("/")[iconUrl.split("/").length - 1]?.split(".")[0] : "activity") + ".svg";
  return (
    <ListItemIcon style={{ minWidth: 5 }}>
      {iconUrl?.length > 0 && theme == "light" ? <img src={ICONS_DARK[imageName]} /> : null}
      {iconUrl?.length > 0 && theme == "dark" ? <img src={ICONS_LIGHT[imageName]} /> : null}
    </ListItemIcon>
  );
};

export const AcuityNeedItem = ({ text, theme = "dark" }: any) => {
  let acuity;
  if (text === 1) acuity = "B";
  else if (text === 2) acuity = "C";
  else if (text === 3) acuity = "D";
  else if (text === 4) acuity = "E";
  else if (text === 5) acuity = "H";
  else if (text === 6) acuity = "M";
  else if (text === 7) acuity = "L";

  return (
    <ListItemIcon style={{ padding: 5, minWidth: 5 }}>
      <span
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "11px",
          height: "11px",
          borderRadius: 3,
          fontWeight: 700,
          fontSize: 13,
          padding: 4,
          color: theme == "dark" ? "#000" : "#fff",
          background: theme == "dark" ? "#FFF" : "#000",
        }}
      >
        {acuity}
      </span>
    </ListItemIcon>
  );
};

export const PriorityBadge = ({ priority }: any): JSX.Element => {
  const getColor = (priority: number) => {
    switch (priority) {
      case 1:
        return "#941212";
      case 2:
        return "#B95900";
      case 3:
        return "#1f4366";
      default:
        return "#1f4366";
    }
  };
  return (
    <span
      style={{
        padding: "2px 6px",
        borderRadius: 2.7,
        fontWeight: 700,
        fontSize: 14,
        backgroundColor: getColor(priority),
      }}
    >
      {priority}
    </span>
  );
};
